import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ActionItemDynamicForm = Loadable(
  lazy(() =>
    import("./ActionItemDynamicForm").then(({ ActionItemDynamicForm }) => ({
      default: ActionItemDynamicForm,
    })),
  ),
);

const ManageActionItemDynamicForm = Loadable(
  lazy(() =>
    import("./ManageActionItemDynamicForm").then(
      ({ ManageActionItemDynamicForm }) => ({
        default: ManageActionItemDynamicForm,
      }),
    ),
  ),
);

export const ActionItemDynamicFormRoutes = [
  {
    path: "/action-item-dynamic-form",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_DYNAMIC_FORM]}>
        <ActionItemDynamicForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/action-item-dynamic-form/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_DYNAMIC_FORM]}>
        <ManageActionItemDynamicForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/action-item-dynamic-form/manage/:formId",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.ACTION_ITEM_DYNAMIC_FORM]}>
        <ManageActionItemDynamicForm />
      </AuthorizedRoute>
    ),
  },
];
